import styled, {css} from "styled-components";
import {styledByDevice} from "../../../../../../../themes/architecture/styled-by-device";

export interface LanguageSwitcherItemCheckboxProps {
  isChecked: boolean;
}

const DefaultBox = styled.div<LanguageSwitcherItemCheckboxProps>``;

const PcBox = styled(DefaultBox)`
  display: none;
`;

const MobileBox = styled(DefaultBox)`
  width: 25px;
  height: 25px;
  margin: 0 1rem 0 0;
  background-color: ${props => props.theme.colors.background};
  border-radius: 50%;

  ${props => props.isChecked && css`
    background-image: url(${props => props.theme.images.spriteSheet.toString()});
    background-position: -394px -521px;
  `}
`;

export const LanguageSwitcherItemCheckboxDefaultBox = styledByDevice(PcBox, MobileBox);
